<template>

    <div class="loar">

        <div v-show="loading">
            <foxy-loader></foxy-loader>
            <p class="text-lRegular color__moon mt__16">{{ $t('connexion_in_progress') }}</p>
        </div>

        <div v-show="error">
            <img src="/img/login/error.svg" class="img__64">
            <p class="text-lSemibold mt__16">{{ $t('magic_error_title') }}</p>
            <p class="text-baseRegular color__moon mt__4">{{ $t('invalid_credential_cta_try_again') }}</p>
            <button class="cta-medium-primary mt__32">{{ $t('invalid_credential_cta_try_again') }}</button>

            <div class="cancel" @click="cancel">
                <img src="/img/icons/cancel-blue.svg" class="img__20 mr__4">
                <span class="text-lSemibold color__aquamarine">{{ $t('give-up') }}</span>
            </div>
        </div>


        <div class="popup-container" v-if="showImapDisable">
            <div class="popup-shadow"></div>
            <div class="popup">
                <img class="img__64" src="/img/login/error.svg">
                <h1 class="text-xlSemibold mt__16">{{$t('activate_imap_microsoft_title')}}</h1>
                <div class="divider"></div>
                <p class="text-baseSemibold">{{$t('steps_to_follow')}}</p>
                <div class="list mt__16">
                    <div class="feed">
                        <blue-point :fisrt="true"/>
                        <markdown class="text-baseRegular"
                                  :text="$t('follow_link_settings', 0, {settings_microsoft: 'https://outlook.live.com/mail/0/options/mail/forwarding'})"
                                  :blank="true"></markdown>
                    </div>
                    <div class="feed">
                        <blue-point/>
                        <markdown class="text-baseRegular" :text="$t('go_to_imap_tab')"></markdown>
                    </div>
                    <div class="feed">
                        <blue-point/>
                        <markdown class="text-baseRegular" :text="$t('log_in_activate_2FA')"></markdown>
                    </div>
                    <div class="feed">
                        <blue-point/>
                        <markdown class="text-baseRegular" :text="$t('activate_imap_save')"></markdown>
                    </div>
                    <div class="feed">
                        <blue-point :last="true"/>
                        <markdown class="text-baseRegular" :text="$t('its_activated_continue')"></markdown>
                    </div>
                    <div class="actions">
                        <button class="cta-medium-tertiary" @click="cancel">{{$t('global_close')}}</button>
                        <div class="mr__16"></div>
                        <button class="cta-medium-primary" @click="retry">{{$t('valid_imap_enable')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import Auth from '../modules/auth'
import Consent from '../modules/consent'
import Login from '../modules/login'
import OAuthMicrosoft from '../modules/o-auth/microsoft'
import UserFlow from '../modules/userFlow'

import BluePoint from '../components/loginFlow/BluePoint'
import FoxyLoader from '../components/FoxyLoader'
import Markdown from '../components/Markdown'

import SessionStorage from '../helpers/sessionStorage'


export default {

    name: 'login-o-auth-redirect',

    components: {
        BluePoint,
        FoxyLoader,
        Markdown
    },

    computed: {
        ...Vuex.mapGetters([
            'isConnected'
        ]),
        loading() {
            return !this.error
        }
    },

    data() {
        return {
            error: false,
            provider: 'microsoft',
            showImapDisable: false
        }
    },

    async mounted() {

        await this.initData()

    },

    methods: {


        async initData() {
            try {

                // code=M.C540_BAY.2.U.bf573cf7-1f20-627f-82e5-740625563e70&state=step1    =>   microsoft imap is disable
                const {oAuthCodeVerifier, email} = OAuthMicrosoft.getOAuthStep1Data()
                const oAuthCode = this.$route.query.code
                const query = this.$route.query

                if (query.state === 'step1') {
                    // Connect the oauth account to Cleanfox/Foxbrain using a refresh token
                    const connectResult = await Auth.connect(this, email, undefined, this.provider, {
                        oAuthCode,
                        oAuthCodeVerifier
                    })

                    Consent.acceptConsent(email, this.provider)
                    Login.postConnectRoute(this, this.provider, connectResult)
                } else {
                    console.error('LoginOAuthRedirect: Error during login-o-auth state:', query.state)
                    this.error = true

                    if(query.state && query.state.message === 'imap_disabled') {
                        this.showImapDisable = true
                    }
                }
            } catch (error) {
                console.error('LoginOAuthRedirect: Error during login-o-auth', error)
                this.error = true

                if(error && error.message === 'imap_disabled') {
                    this.showImapDisable = true
                }
            }
        },

        cancel() {
            SessionStorage.removeItem(SessionStorage.KEYS.EMAIL)
            this.isConnected
                ? this.$router.push({path: '/add-inbox'})
                : this.$router.push({path: '/'})
        },

        retry() {
            const path = UserFlow.getLoginPathPostMagicForm({provider: this.provider, isOAuth: true})
            this.routerPush(path)
        }
    }
}
</script>

<style lang="scss" scoped>

.loar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: relative;

    > div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .cancel {
        position: absolute;
        top: 24px;
        right: 16px;
        display: flex;
        cursor: pointer;
        @media screen and (min-width: $above-tablet-length) {
            top: 40px;
            right: 40px;
        }
    }
}

.popup-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-content: center;
    justify-content: center;
    .popup-shadow {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5)
    }
    .popup {
        margin: 16px;
        padding: 24px 16px;
        background-color: $white;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        z-index: 1;
        max-width: 454px;
        text-align: start;

        @media screen and (min-width: $above-tablet-length) {
            padding: 32px;
        }

        .divider {
            width: 100%;
            height: 1px;
            background-color: $platinum;
            margin: 16px 0;
        }
        .feed {
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: flex-start;

            > :first-child {
                margin-right: 12px;
                &:lang(ar-sa) {
                    margin-right: 0;
                    margin-left: 12px;
                }
            }

            > :last-child {
                padding-bottom: 16px;
            }
        }
        .actions {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 16px;
        }

    }
}

</style>